import Class from './c-content-chart-tree-map';
import './c-content-chart-tree-map@.vue';

export default Class;